import { useEffect } from "react";

import { Colors } from "@blueprintjs/core";
import Scroll from "react-scroll";

import { Flex } from "@/components/layout/flexbox";

import { MessageWithEllipsis } from "./MessageWithEllipsis";

interface ConfirmMessageProps {
  visible: boolean;
  message: string;
}

export function ConfirmMessage({ visible, message }: ConfirmMessageProps) {
  useEffect(() => {
    if (visible) {
      Scroll.animateScroll.scrollToBottom();
    }
  }, [visible]);

  return (
    <Flex justifyContent="center" style={{ overflow: "hidden" }} p={1}>
      <Flex
        style={{
          transform: visible ? "translateY(0%)" : "translateY(-200%)",
          transition: "transform 500ms",
          fontSize: 22,
          color: Colors.GRAY2,
          whiteSpace: "nowrap",
        }}
        width={message.length * 11 + 16}
        alignItems="center"
      >
        <MessageWithEllipsis>{message}</MessageWithEllipsis>
      </Flex>
    </Flex>
  );
}
